export default __webpack_public_path__ + "static/media/car-icon.aa5bd486.svg";